import { IconCalendarWeek, IconClockCheck, IconEdit, IconInfoCircle, IconMoneybag, IconPlus, IconShoppingBag, IconTrash } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  activesalon,
  getAllSalons,
  handleBestSeller,
  salonDelete,
} from "../../../redux/slice/salonSlice";
import {
  permissionError,
  permissionErrorForDemo,
  warning,
} from "../../../util/Alert";
import Button from "../../extras/Button";
import Pagination from "../../extras/Pagination";
import Searching from "../../extras/Searching";
import Table from "../../extras/Table";
import ToggleSwitch from "../../extras/ToggleSwitch";
import LazyImage from "../../extras/ImageFallback";

export const Salon = () => {
  // const dummysalons = Dummy(10000);
  const [data, setData] = useState([]);

  const { salon } = useSelector((state) => state.salon);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const hasPermission = useSelector((state) => state.auth.admin.flag);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  useEffect(() => {
    const payload = {
      start: page,
      limit: rowsPerPage,
      search,
    };
    dispatch(getAllSalons(payload));
  }, [page, rowsPerPage, search]);

  useEffect(() => {
    setData(salon);
  }, [salon]);

  function openImage(imageUrl) {
    // Open the image in a new tab or window
    window.open(imageUrl, "_blank");
  }

  const handleInfo = (id) => {
    if (id === "65f90e5c884529ab279fe879") return permissionError();

    navigate("/admin/salon/salonProfile", {
      state: {
        id,
      },
    });
  };

  const salonTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "Image",
      Cell: ({ row }) => (
        <div className="userProfile">
          <LazyImage
            src={row && row.mainImage}
            alt="images"
            className="cursor-pointer"
            onClick={() => openImage(row && row.image)}
            style={{ height: "50px", width: "50px", overflow: "hidden" }}
            height={`100%`}
          />
        </div>
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => (
        <span
          className="text-capitalize cursor"
          onClick={() => handleInfo(row._id)}
        >
          {row?.name}
        </span>
      ),
    },
    {
      Header: "Mobile No",
      Cell: ({ row }) => <span>{row?.mobile ? row?.mobile : "-"}</span>,
    },
    {
      Header: "Platform Fee (%)",
      body: "platformFee",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <span className="text-capitalize ">{row?.platformFee}</span>
      ),
    },
    {
      Header: "Country",
      Cell: ({ row }) => <span>{row?.addressDetails?.country}</span>,
    },
    {
      Header: "Active",
      body: "isActive",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <ToggleSwitch
          value={row?.isActive}
          onClick={() => {
            if (!hasPermission) return permissionError();
            if (row?._id === "6617c5ded03f8d115d62afe5")
              return permissionError();

            dispatch(activesalon(row?._id));
          }}
        />
      ),
    },
    {
      Header: "Best Seller",
      body: "isBestSeller",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <ToggleSwitch
          value={row?.isBestSeller}
          onClick={() => {
            if (!hasPermission) return permissionError();
            dispatch(handleBestSeller(row?._id)).then((res) => {
              if (res?.payload?.status) {
                toast.success(res?.payload?.message);
                const payload = {
                  start: page,
                  limit: rowsPerPage,
                  search,
                };
                dispatch(getAllSalons(payload));
              } else {
                toast.error(res?.payload?.message);
              }
            });
          }}
        />
      ),
    },

    {
      Header: "Schedule",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => handleScheduleInfo(row)}
          >
            <IconCalendarWeek className="text-secondary"/>
          </button>
        </div>
      ),
    },
    {
      Header: "Booking",
      body: "booking",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => handleOpenBookings(row)}
          >
            <IconClockCheck className="text-secondary" />
          </button>
        </div>
      ),
    },
    {
      Header: "Order",
      body: "order",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"        
          onClick={() => handleOpenOrders(row)}
        >

          
            <IconShoppingBag className="text-secondary" />
          </button>
        </div>
      ),
    },
    {
      Header: "Info",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => handleInfo(row?._id)}
          >
            <IconInfoCircle className="text-secondary" />
          </button>
          <button
            className="btn btn-sm"
            onClick={() => handleEarning(row)}
          >
            <IconMoneybag className="text-secondary" />
          </button>
        </div>
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
       <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => {
              handleAddSalon(row);
            }}
          >
           <IconEdit className="text-secondary" />
          </button>
          <button
           className="btn btn-sm"
            onClick={() => handleDelete(row?._id)}
          >
            <IconTrash className="text-secondary" />
          </button>
        </div>
      ),
    },
  ];

  const handleAddSalon = (row) => {
    if (row?._id === "6617c5ded03f8d115d62afe5") return permissionError();

    navigate("/admin/salon/addSalon", {
      state: {
        row,
      },
    });
  };

  const handleEarning = (row) => {
    if (row?._id === "6617c5ded03f8d115d62afe5") return permissionError();

    navigate("/admin/salon/income", {
      state: {
        row,
      },
    });
  };

  const handleDelete = async (id) => {
    if (!hasPermission) return permissionError();
    if (id === "6617c5ded03f8d115d62afe5") return permissionError();

    if (id === "6842d5fe18181364fb768440")
      return permissionErrorForDemo("Salon");
    try {
      const data = await warning("Delete");
      const yes = data?.isConfirmed;
      console.log("yes", yes);
      if (yes) {
        dispatch(salonDelete(id));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleScheduleInfo = (id) => {
    navigate("/admin/allSalon/schedule", { state: id });
  };
  const handleOpenBookings = (row) => {
    navigate("/admin/salon/bookings", { state: { data: row } });
  };
  const handleOpenOrders = (row) => {
    navigate("/admin/salon/orders", { state: { data: row } });
  };

  return (
    <div className="userPage">
      <div className="user-table mb-3">
        <div className="user-table-top">
          <div className=" d-flex justify-content-between align-items-center w-100 ">
            <div className="w-100">
              <h5
                className="main-title">
                Saloon
              </h5>
            </div>
            <div className="d-flex gap-2 justify-content-end w-100">
            <Searching
              type={`server`}
              data={data}
              setData={setData}
              column={salonTable}
              serverSearching={handleFilterData}
            />
            <Button
                text={`Add salon`}
                bIcon={<IconPlus height={18} width={18} />}
                onClick={() => handleAddSalon()}
              />
            </div>
          </div>
        </div>
        <Table
          data={data}
          mapData={salonTable}
          PerPage={rowsPerPage}
          Page={page}
          type={"client"}
        />
        <Pagination
          type={"client"}
          serverPage={page}
          setServerPage={setPage}
          serverPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          totalData={data?.length}
        />
      </div>
      {/* 

      <Searching
        type={`server`}
        data={data}
        setData={setData}
        column={salonTable}
        serverSearching={handleFilterData}
      /> */}

      
        
      
    </div>
  );
};
